import {
  Button,
  Dialog as MuiDialog,
  DialogActions as MuiDialogActions,
  DialogContent as MuiDialogContent,
} from '@global-engineering-shared/gweb-material-ui';
import React from 'react';

import DialogTitle from 'components/Dialog/components/DialogTitle';
import useStyles from 'components/Dialog/Dialog.styles';

type DialogProps = {
  isOpen: boolean;
  handleClose: () => void;
  handleContinue?: () => void;
  name: string;
  title: string;
  content: React.ReactNode;
  showContinueButton?: boolean;
};

const Dialog = ({
  isOpen,
  handleClose,
  handleContinue,
  name,
  title,
  content,
  showContinueButton = true,
}: DialogProps) => {
  const classes = useStyles();

  return (
    <MuiDialog
      className={classes.root}
      open={isOpen}
      onClose={handleClose}
      data-testid={`${name}Dialog`}
    >
      <DialogTitle title={title} handleClose={handleClose} />
      <MuiDialogContent>{content}</MuiDialogContent>
      <MuiDialogActions className={classes.actions}>
        {showContinueButton && (
          <Button onClick={handleContinue} color="primary" variant="contained">
            Continue
          </Button>
        )}
      </MuiDialogActions>
    </MuiDialog>
  );
};

export default Dialog;
